import { render, staticRenderFns } from "./akm.vue?vue&type=template&id=0f52a1eb&scoped=true"
import script from "./akm.vue?vue&type=script&lang=js"
export * from "./akm.vue?vue&type=script&lang=js"
import style0 from "./akm.vue?vue&type=style&index=0&id=0f52a1eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f52a1eb",
  null
  
)

export default component.exports